T.Form = {
	isValidEmail: function(email) {
		let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}
};

/**
 * @class {T.Form.Base}
 * @extends {mkE.Base}
 */
T.Form.Base = Class(
	/**
	 * @lends {T.Form.Base#}
	 */
	{
		__NAME: 'T.Form.Base',

		_itemNode: null,
		_captionNode: null,

		/**
		 * @param {T.Form.Base.Par} par
		 */
		_par: function(par){
			if( par.caption ){
				this.caption(par.caption);
			}
			if( par.error ){
				this.error(par.error);
			}
			if( par.help ){
				this.help(par.help);
			}
		},

		caption: function(caption){
			if( !this._captionNode ){
				return;
			}
			if( !caption ){
				addClassName(this._captionNode, 'hidden');
			}else{
				removeClassName(this._captionNode, 'hidden');
			}
			clearNode(this._captionNode);
			mkE.appendTypeElement(this._captionNode, caption);
		},

		_getErrorNode: function(){
			this._errorNode = mkE({
				tag: 'div',
				className: 'invalid-feedback'
			});
			return this._errorNode;
		},

		error: function(error){
			if( !this._errorNode ){
				return;
			}
			if( !error ){
				removeClassName(this._itemNode, 'is-invalid');
			}else{
				addClassName(this._itemNode, 'is-invalid');
			}
			clearNode(this._errorNode);
			mkE.appendTypeElement(this._errorNode, error);
			return error;
		},

		success: function( msg ){
            if( !this._errorNode ){
                return;
            }
            removeClassName(this._itemNode, 'is-invalid');
            addClassName(this._errorNode, 'is-ok');
            clearNode(this._errorNode);
            mkE.appendTypeElement(this._errorNode, msg);
		},

		_getHelpNode: function(){
			this._helpNode = mkE({
				tag: 'small',
				className: 'form-help'
			});
			return this._helpNode;
		},

		help: function(help){
			if( !this._helpNode ){
				return;
			}
			if( !help ){
				addClassName(this._helpNode, 'hidden');
			}else{
				removeClassName(this._helpNode, 'hidden');
			}
			clearNode(this._helpNode);
			mkE.appendTypeElement(this._helpNode, help);
		}
	},
	mkE.Base
);

/**
 * @class {T.Form.Base.Par}
 */
T.Form.Base.Par = Class(
	/**
	 * @lends {T.Form.Base.Par#}
	 */
	{
		__NAME: 'T.Form.Base.Par',

		caption: '',
		help: '',
		error: ''
	}
);
